export const ANALYTICS_DEFAULT_CONFIG = {
  logLevel: 1, // use error logging, see amplitude.Types.LogLevel for values
  serverUrl: 'https://api2.analyticspodium.com/2/httpapi'
};

export const EXPERIMENT_DEFAULT_CONFIG = {
  serverUrl: 'https://lab.analyticspodium.com'
};

export const AMPLITUDE_DEPRECATED_CONFIG_KEYS = [
  'includeReferrer',
  'includeUtm',
  'includeGclid',
  'includeFbcli',
  'batchEvents',
  'saveEvents',
  'eventUploadPeriodMillis'
];
